import Rest from './rest'
import config from '../../configjson'
const dataServer: Rest = new Rest(config.data_server_url)
export default dataServer